import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { Checkbox } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';

import { CheckboxesConnectProps, CheckBoxFieldPropsDispatchers, FieldStateProps } from './types';
import { FieldSet } from './FieldSet';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { CheckboxProps } from 'semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox';
import Immutable from 'immutable';

const CheckboxesConnect = ({
  label,
  id,
  name,
  modifiers = [],
  autoFocus = false,
  tabIndex = 1,
  disabled = false,
  value = Immutable.fromJS([]) as Immutable.List<string>,
  required = false,
  dispatchChangeField,
  errors,
  options,
  info,
  screen,
  intl,
}: CheckboxesConnectProps & InjectedIntlProps) => {
  const handleClickCheckbox = (event: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    dispatchChangeField(event, data, value);
  };
  return (
    <FieldSet id={id} label={label} required={required} modifiers={modifiers.concat(['light-label', id ?? ''])} errors={errors}>
      <React.Fragment>
        <div className="form-radio__content">
          {options.map((option: { value: string; label: string }, index: number) => (
            <Checkbox
              key={`${name}-${screen ? `/${screen}` : ''}-${index}`}
              // Adds screen to the name to avoid having two components with the same name
              name={`${name}${screen ? `/${screen}` : ''}`}
              value={option.value}
              label={intl.formatMessage({ id: option.label, defaultMessage: localeData.en[option.label] })}
              checked={value.includes(option.value)}
              onChange={handleClickCheckbox}
              data-testid={`form__radio--${id}-${option.value}`}
              autoFocus={autoFocus}
              tabIndex={tabIndex}
              disabled={disabled}
            />
          ))}
        </div>
        {info && (
          <div className="info_small">
            <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
          </div>
        )}
      </React.Fragment>
    </FieldSet>
  );
};

const mapStateToProps = (state: StateType, ownProps: CheckboxesConnectProps): FieldStateProps => ({
  value: state.getIn(ownProps.pathValue),
  errors: state.getIn(ownProps.pathErrors),
});

const mapDispatchToProps = (dispatch: Dispatch<any>, ownProps: CheckboxesConnectProps): CheckBoxFieldPropsDispatchers => ({
  dispatchChangeField: (_: any, data: any, prevValue: Immutable.List<string>) => {
    // Remove screen from name
    const name = data.name.split('/')[0];

    const checkboxValue = data.value;
    let newValue;
    if (prevValue.includes(checkboxValue)) {
      newValue = prevValue.filter((val: any) => val !== checkboxValue);
    } else {
      newValue = [...prevValue, checkboxValue];
    }

    return dispatch(
      ownProps.onChangeFieldAction({
        value: newValue,
        name,
        id: data.id,
      })
    );
  },
});

export default compose<any>(
  connect<FieldStateProps, (dispatch: Dispatch<any>, ownProps: CheckboxesConnectProps) => CheckBoxFieldPropsDispatchers, any, StateType>(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(CheckboxesConnect);
